import { Box, Heading, Text } from '@chakra-ui/react';
import React from 'react';

import CustomImage from '@/app/_components/custom-image/CustomImage';
import LinkCustom from '@/app/_components/link/LinkCustom';
import { getImageLink } from '@/services/link.service';
import { ImageTransformationKeys } from '@/types/files/files.types';
import { CallToAction } from '@/types/new-cars/new-cars.types';

import Styles from './MatchBanner.module.scss';

type Props = {
  call_to_actions: CallToAction;
};

const imageKey: ImageTransformationKeys = {
  mobileKey: 'image-430-305',
  desktopKey: 'image-1440-820',
};
const MatchBanner = ({ call_to_actions }: Props) => {
  return (
    <Box className={Styles.matchBannerWrapper}>
      <CustomImage
        imageKeys={imageKey}
        imageSrc={getImageLink(call_to_actions?.image) ?? ''}
        alt={call_to_actions?.text ?? 'Finance car'}
        width={1440}
        height={811}
        className={Styles.matchBannerImage}
      />

      <Box className={Styles.matchBannerContent}>
        <Box className={Styles.headingElement}>
          <Heading
            as="h3"
            className={Styles.titleLg}
            marginBottom={{ base: 4, md: 6 }}
          >
            {call_to_actions?.heading}
          </Heading>
          <Text
            className={Styles.titleText}
            marginBottom={{ base: 5, md: 6 }}
            marginX={{ base: 'initial', lg: 'auto' }}
            maxWidth={'462px'}
          >
            {call_to_actions?.subheading}
          </Text>
          <LinkCustom
            extraClass="btnSm"
            href={call_to_actions?.url}
            moduleClass={Styles.findBtn}
          >
            {call_to_actions?.text}
          </LinkCustom>
        </Box>
      </Box>
    </Box>
  );
};

export default MatchBanner;
